import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  Button,
  Alert,
  AlertIcon,
  useTheme,
  Link,
} from '@chakra-ui/react';
import { CONTAINER_MAX_WIDTH_1 } from 'src/constants/ui';
import { MarketplaceInfo } from 'src/api/v1-api';
import { FREE_TIER_POSITION } from 'src/components/organisms/tier-options';

interface Props {
  marketplace: MarketplaceInfo | null;
}

export const SampleListingsBanner = ({ marketplace }: Props) => {
  const theme = useTheme();

  if (!(marketplace?.tier?.position === FREE_TIER_POSITION && marketplace?.status === 'preview')) {
    return null;
  }

  return (
    <Box as="section" w="full">
      <Container maxW={CONTAINER_MAX_WIDTH_1} py={{ base: 2, md: 3 }}>
        <Alert
          status="info"
          borderRadius={theme.border_radius.border_radius_1}
          bg="lomaGreen.50"
          borderColor="lomaGreen.200"
          borderWidth="1px"
        >
          <AlertIcon color="lomaGreen.500" />
          <Stack
            spacing="2"
            justify={{ base: 'start', md: 'space-between' }}
            direction={{ base: 'column', md: 'row' }}
            align={{ base: 'start', md: 'center' }}
            w="full"
          >
            <Box>
              <Text fontWeight="medium" color="lomaGreen.900">
                Sample listings are for preview purposes at free tier
              </Text>
              <Text color="lomaGreen.700" fontSize="sm">
                Upgrade your marketplace plan before launching to keep your sample listings
              </Text>
            </Box>
            <Button
              size="sm"
              as={Link}
              href={`mailto:contact@withloma.com?subject=Upgrade for ${encodeURIComponent(
                'Sample Listings',
              )}`}
              flexShrink={0}
              border="2px solid"
              borderColor="lomaGreen.400"
              bg="white"
              color="lomaGreen.900"
              rel="noopener noreferrer"
              target="_blank"
              _hover={{
                bg: 'gray.50',
                color: 'lomaDarkGreen.900',
                borderColor: 'lomaGreen.400',
                transform: 'translateY(-1px)',
                textDecoration: 'none',
              }}
            >
              Upgrade Plan
            </Button>
          </Stack>
        </Alert>
      </Container>
    </Box>
  );
};

export default SampleListingsBanner;
